import React from 'react';

const DESTINATIONS = [
  { img: 'https://images.unsplash.com/photo-1528164344705-47542687000d?w=600&q=65', name: '大理', score: '4.9', ppl: '2,341' },
  { img: 'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=600&q=65', name: '川西', score: '4.8', ppl: '1,892' },
  { img: 'https://images.unsplash.com/photo-1499678329028-101435549a4e?w=600&q=65', name: '厦门', score: '4.7', ppl: '3,102' },
  { img: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=600&q=65', name: '成都', score: '4.9', ppl: '5,210' },
];

const DestinationsSection = () => {
  return (
    <section id="dest" className="py-24">
      <div className="max-w-5xl mx-auto px-6">
        <div className="flex items-center justify-between mb-8" style={{ animation: 'rise .75s ease-out both' }}>
          <div>
            <h2 className="text-3xl md:text-4xl font-bold mb-2 cb is">热门目的地</h2>
            <p className="text-sm cm">星辰大海，皆是心之所向</p>
          </div>
          <a href="#" className="text-sm cg hover:underline cursor-pointer">更多 →</a>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {DESTINATIONS.map((d, i) => (
            <div key={i} className="frost overflow-hidden cursor-pointer relative" style={{ minHeight: 120, animation: `rise .75s ease-out ${i * 0.08}s both` }}>
              <img src={d.img} alt={d.name} className="absolute inset-0 w-full h-full object-cover" loading="lazy" onError={(e) => e.target.style.display = 'none'} />
              <div className="absolute inset-0" style={{ background: 'linear-gradient(180deg, rgba(22,37,68,0.3) 0%, rgba(22,37,68,0.75) 100%)' }} />
              <span className="absolute top-3 left-3 ls" style={{ zIndex: 2 }}>⭐{d.score}</span>
              <div className="absolute bottom-0 left-0 right-0 p-4" style={{ zIndex: 2 }}>
                <div className="text-base font-semibold cb">{d.name}</div>
                <div className="text-[11px] cd">{d.ppl} 人已打卡</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DestinationsSection;
